import React from "react";
import { SideMenu, BackHeader } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { IoMdCall } from "react-icons/io";
import { MdOutlineLocationOn } from "react-icons/md";
import CoverImage from "./../../../assets/images/profileHeader.png";
import Typography from "@mui/material/Typography";
import ModeOfTravelIcon from "@mui/icons-material/ModeOfTravel";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { GrFacebookOption, GrTwitter } from "react-icons/gr";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
const OrganizeTripView = () => {
  const navigate = useNavigate();
  return (
    <SideMenu>
      <div className="page-details-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
              <p className="data-view-heading">Lorem ipsum dolor sit amet</p>
              <div className="data-view-header-location-main">
                <MdOutlineLocationOn color="#663399" size={25} />
                <p className="data-view-header-location">burnside</p>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={6}>
              <Button className="header-button" variant="text">
                <p className="page-header-button-text">Download</p>
              </Button>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={6}>
              <Button
                className="header-button"
                variant="text"
                onClick={() => navigate("/organize-trip/book")}
              >
                <p className="page-header-button-text">Book Online</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <img src={CoverImage} className="data-view-header-cover-image" />
        <div className="data-view-cover-footer-container">
          <div className="data-view-cover-footer">
            <p className="data-view-cover-footer-date">
              14 march 2022 - 22 march 2022
            </p>
          </div>
          <p className="data-view-cover-footer-data">$2000</p>
        </div>

        <div className="data-view-cover-footer-container">
          <div className="data-view-cover-footer">
            <div className="heading-main">
              <ModeOfTravelIcon color="#663399" size={30} />
              <p className="icon-heading">
                Nullam vel erat et tortor gravida iaculis eu nec leo
              </p>
            </div>
          </div>
          <p className="data-view-cover-footer-data">International Trip</p>
        </div>
        <div className="data-view-cover-footer-container">
          <div>
            <p className="data-view-cover-footer-data">
              Tutor name: Willow Anderson
            </p>
            <p className="icon-heading">willowAnderson@gmail.com</p>
          </div>

          <div className="heading-main">
            <IoMdCall color="#000" size={30} />
            <p className="data-view-cover-footer-data"> +971 1234567890</p>
          </div>
        </div>
        <div className="data-view-cover-footer-container">
          <div className="data-view-cover-footer">
            <p className="data-view-cover-footer-date"></p>
          </div>
          <div className="share-main">
            <p className="data-view-cover-footer-data">share</p>
            <div>
              <button className="share-button">
                <GrFacebookOption color="white" size={20} />
              </button>
              <button className="share-button">
                <FaLinkedinIn color="white" size={20} />
              </button>
              <button className="share-button">
                <GrTwitter color="white" size={20} />
              </button>
              <button className="share-button">
                <FaWhatsapp color="white" size={20} />
              </button>
            </div>
          </div>
        </div>
        <p className="description-heading">Discription</p>
        <p className="data-view-description">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in lorem
          congue, euismod urna vitae, porttitor mi. Aliquam consectetur eu
          turpis ac congue. <br /> <br />
          Curabitur viverra nunc cursus est efficitur, sit amet ornare felis
          accumsan. Ut eget elementum sem. Sed et nibh pharetra. Lorem ipsum
          dolor sit amet, consectetur adipiscing elit. In in lorem congue,
          euismod urna vitae, porttitor mi. Aliquam consectetur eu turpis ac
          congue. <br /> <br />
          Curabitur viverra nunc cursus est efficitur, sit amet ornare felis
          accumsan. Ut eget elementum sem. Sed et nibh pharetra.
        </p>
        <p className="description-heading">Trip Activities</p>
        <br />
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>
              <div className="day-main">
                <p className="data-view-card-title">Day 1 ~</p>
                <p className="data-view-card-title">15/03/2022</p>
              </div>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="data-view-card-list-main">
              <div>
                <p className="data-view-card-list-heading">Lorem Impusum</p>
                <p className="data-view-card-list-description">
                  Sed commodo sit amet leo non dapibus. Donec sit amet metus
                  quis nunc imperdiet dapibus. Pellentesque vel odio bibendum
                  ante euismod iaculis.
                </p>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
        <br />
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>
              <div className="day-main">
                <p className="data-view-card-title">Day 2 ~</p>
                <p className="data-view-card-title">15/03/2022</p>
              </div>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="data-view-card-list-main">
              <div>
                <p className="data-view-card-list-heading">Lorem Impusum</p>
                <p className="data-view-card-list-description">
                  Sed commodo sit amet leo non dapibus. Donec sit amet metus
                  quis nunc imperdiet dapibus. Pellentesque vel odio bibendum
                  ante euismod iaculis.
                </p>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
        <br />
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>
              <div className="day-main">
                <p className="data-view-card-title">Day 3 ~</p>
                <p className="data-view-card-title">15/03/2022</p>
              </div>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="data-view-card-list-main">
              <div>
                <p className="data-view-card-list-heading">Lorem Impusum</p>
                <p className="data-view-card-list-description">
                  Sed commodo sit amet leo non dapibus. Donec sit amet metus
                  quis nunc imperdiet dapibus. Pellentesque vel odio bibendum
                  ante euismod iaculis.
                </p>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </SideMenu>
  );
};
export default OrganizeTripView;
